var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.2c674572a1f15b1e04c6d68cb484bbb4.svg#y';
                    var viewUrl = 'sprites.2c674572a1f15b1e04c6d68cb484bbb4.svg#view-y';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 32 32',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };